<template>
  <div class="register absolute" style="background:#fff;">
    <div class="shading" style="padding:0 40px;">
      <div
        class="pictrue acea-row row-center-wrapper"
        style="height: 1.22rem;"
      ></div>
      <div class="biaoti">
        <div style="display:flex;align-items:center;justify-content: center;">
          <img
            src="../../assets/images/img/img/logo.png"
            style="width: 120px;height: 120px;border-radius:15px;"
            alt=""
          />
        </div>
        <!-- {{ $t('m.dl_span0') }}！ -->
        <!-- <div style="font-size:13px;color:#999;margin-top:6px;">{{ $t('m.dl_span1') }}</div> -->
      </div>
    </div>

    <div class="register_block">
      <div class="register_block_list" style="margin-top:28px;">
        +
        <input style="width: 34px;" type="text" v-model="value" />
        <country-code-selector
          style="background-color:#fff;"
          :countryCode.sync="value"
        ></country-code-selector>
        <input
          v-model="username"
          :placeholder="$t('m.dl_span2')"
          style="padding-left:10px;"
        />
      </div>
      <div class="register_block_list">
        <input
          v-model="password"
          type="password"
          :placeholder="$t('m.dl_span3')"
        />
      </div>
    </div>
    <!-- <p
        @click="login1"
        style="padding-left:45px; display:inline-block; font-weight:bold;color:red;font-size:15px;line-height:40px;"
      >
        短信登录
      </p> -->

    <div
      class="tip"
      style="padding:0 40px; display: flex;align-items: center;justify-content: space-between; color:#666;margin-top:10px;"
    >
      <!-- <span @click="$router.push({ name: 'RetrievePassword' })" class="" style="font-size:14px;color:#FF4438;">{{ $t('m.dl_span5') }}?</span> -->
      <!-- <span @click="goTo()" style="font-size: 14px;color:#333;">
				{{ $t('m.dl_span01') }}
				<span style="color:#FF4438;">{{ $t('m.dl_span02') }}</span>
			</span> -->
      <!-- <span @click="goTo()" class="" style="font-size: 0.2rem;">立即注册</span> -->
    </div>
    <div style="padding:0 40px">
      <van-button class="register_submit" @click="submit">{{
        $t("m.dl_span6")
      }}</van-button>
      <!-- <div style="display:flex;align-items:center;font-size:12px;color:#999;margin-top:0px;height: 40px;">
				<img src="../../assets/images/new/hongxuan.png" style="width: 15px;height: 15px;margin-right:3px;" alt="" />
				{{ $t('m.dl_span5') }}
			</div> -->
      <!-- <van-button class="register_submit" style="color:#1664FC;background:#dfdfdf;margin-top:20px;" @click="goTo()">注册账号</van-button> -->
    </div>

    <div
      v-if="show"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.dl_span12") }}
      </div>
    </div>
    <!-- <div
      v-show="hidshow"
      style="position: fixed; width:100%;bottom:50px;left:0;display:flex;align-items:center;justify-content: center;font-size:13px;color:#777;"
    >
      <img
        src="../../assets/images/bank/f2.jpg"
        style="width: 100%;height: 100px;"
        alt=""
      />
    </div> -->
    <div
      style="display:flex;align-items:center;padding:0 60px;margin-top:30px;font-size:13px;"
    >
      <div style="height: 1px;flex:1;background:#dfdfdf;"></div>
      <span style="color:#666;margin:0 8px;">{{ $t("m.dl_span23") }}</span>
      <div style="height: 1px;flex:1;background:#F5F5F8;"></div>
    </div>
    <div style="display:flex;align-items:center;justify-content:center;">
      <img
        @click="login1()"
        src="../../assets/images/img/img/phone.png"
        style="width: 50px;height: 50px;margin-top:5px;"
        alt=""
      />
    </div>
    <div style="text-align: center;margin-top: 5px;">
      <span style="color:#666;margin:0 8px;">{{ $t("m.dl_span4") }}</span>
    </div>
    <div
      data-v-561126ed=""
      style="border: rgb(255, 98, 65); display: flex; justify-content: center; margin-top: 10px;"
    >
      <a href="#/Register" class="" style="color: rgb(51, 133, 255);"
        ><span
          style="padding: 0px 5px; border-right: 1px solid rgb(222, 222, 222);"
          >立即注册</span
        ></a
      ><a href="#/retrieve_password" class="" style="color: rgb(51, 133, 255);"
        ><span style="padding: 0px 5px;">忘记密码?</span></a
      >
    </div>
    <!--    <div-->
    <!--      style="display:flex;align-items:center;font-size:12px;color:#999;margin-top:10px;height: 40px;justify-content: center;"-->
    <!--    >-->
    <!--      <img-->
    <!--        src="../../assets/images/new/hongxuan.png"-->
    <!--        style="width: 15px;height: 15px;margin-right:3px;"-->
    <!--        alt=""-->
    <!--      />-->
    <!--      {{ $t("m.dl_span24") }}-->
    <!--    </div>-->
    <!-- <div
      v-show="hidshow"
      style="position: fixed; width:100%;bottom:70px;left:0;display:flex;align-items:center;justify-content: center;font-size:13px;color:#777;"
    >
      <img
        src="../../assets/images/yhk/bz.png"
        style="width: 16px;height: 16px;margin-right:5px;"
        alt=""
      />
      中国银保监会实时监管，保障基金交易安全
    </div> -->
  </div>
</template>
<script>
import {
  login,
  loginMobile,

  //registerVerify,
  register,
  getCodeApi
} from "@api/user";
import { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";

import { getLogo } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL } from "@utils";

const BACK_URL = "login_back_url";

export default {
  name: "Login",
  //mixins: [sendVerifyCode],
  data: function() {
    return {
      value: 86,
      kejian: false,
      show: false,
      navList: ["账号登录"],
      current: 0,
      username: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "android",
      tuijianm: "",
      passwords: "",
      isShowCode: false,

      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      hidshow: true //显示或者隐藏footer
    };
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.hidshow = false;
      } else {
        this.hidshow = true;
      }
    }
  },
  mounted: function() {
    window.onresize = () => {
      return (() => {
        this.showHeight = document.body.clientHeight;
      })();
    };

    console.log("记住账号");
    console.log(window.localStorage.getItem("zhanghao"));
    if (window.localStorage.getItem("zhanghao")) {
      this.username = window.localStorage.getItem("zhanghao");
      this.value = window.localStorage.getItem("quhao");
      this.password = window.localStorage.getItem("mima");
    }

    var id = this.$route.query.formItem;
    console.log(id);
    //判断是登录还是注册
    if (id == 1) {
      this.formItem = 1;
    } else if (id == 2) {
      this.formItem = 2;
    }
    this.tuijianm = this.$route.query.spread;
    // 判断是否获取推荐码
    //this.getCode();
    //this.getLogoImage();
  },
  methods: {
    login1() {
      this.$router.push({
        path: "/login1"
      });
    },
    goTo() {
      this.$router.push({
        path: "/Register"
      });
    },
    kejianB() {
      this.kejian = !this.kejian;
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/sms_captcha?" +
        "key=" +
        this.keyCode +
        Date.parse(new Date());
      console.log(this.codeUrl);
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.response.data.msg);
        });
    },
    async getLogoImage() {
      let that = this;
      getLogo(2).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { username, captcha } = that;
      try {
        await that
          .$validator({
            username: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({
            username,
            captcha
          });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      loginMobile({
        phone: that.username,
        captcha: that.captcha,
        spread: cookie.get("spread")
      })
        .then(res => {
          let data = res.data;
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          that.$store.commit("LOGIN", datas);
          // let newTime = Math.round(new Date() / 1000);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          that.$router.replace({
            path: backUrl
          });
        })
        .catch(res => {
          console.log(res);
          this.$dialog.error(res.response.data.msg);
        });
    },
    async register() {
      if (this.password != this.passwords) {
        this.$dialog.toast({
          mes: "两次密码不相同请重新输入!"
        });
        return;
      }
      var that = this;
      const { username, captcha, password } = that;
      try {
        await that
          .$validator({
            username: [required(required.message("手机号码"))],
            captcha: [required(required.message("验证码"))],
            password: [required(required.message("密码"))]
          })
          .validate({
            username,
            captcha,
            password
          });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      register({
        username: that.username,
        captcha: that.captcha,
        password: that.password,
        spread: that.tuijianm
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
        })
        .catch(res => {
          this.$dialog.error(res.response.data.msg);
        });
    },

    navTap: function(index) {
      this.current = index;
    },
    async submit() {
      // this.$router.push({
      // 	path:'/'
      // })

      const { username, password, codeVal } = this;
      try {
        await this.$validator({
          username: [
            required(required.message("账号"))
            // attrs.range([5, 16], attrs.range.message("账号")),
          ],
          password: [
            required(required.message("密码"))
            // attrs.range([6, 16], attrs.range.message("密码")),
          ],
          codeVal: this.isShowCode
            ? [
                required(required.message("验证码"))
                // attrs.length(4, attrs.length.message("验证码")),
              ]
            : []
        }).validate({
          username,
          password,
          codeVal
        });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      this.show = true;
      login({
        area: this.value,
        username: this.value + username,

        password,
        system: codeVal
      })
        .then(data => {
          this.show = false;
          console.log("login", data);
          let expires_time = new Date().getTime() + 86400 * 1000 - 28800000;
          const datas = {
            token: data.data.data.access_token,
            expires_time: expires_time,
            kf: data.data.data.kf,
            view: data.data.data.view
          };

          window.localStorage.setItem("zhanghao", username);
          window.localStorage.setItem("quhao", this.value);
          console.log("记住账号");
          console.log(window.localStorage.getItem("zhanghao"));
          window.localStorage.setItem("mima", password);
          this.$store.commit("LOGIN", datas);
          cookie.remove(BACK_URL);
          this.$router.push({
            path: "/user"
          });
        })
        .catch(e => {
          this.show = false;
          console.log(e);
          this.$dialog.error(e.response.data.msg);
        });
    }
  }
};
</script>
<style scoped>
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}
.register_block {
  padding: 0 40px;
}
.register_block_list {
  width: 100%;
  height: 60px;
  padding: 0 0px;
  /* background: #f1f1f3; */
  /* border-radius: 5px; */
  display: flex;
  align-items: center;
  font-size: 14px;

  border-bottom: 1px solid #eee;
}
.register_block_list input {
  line-height: 60px;
  height: 60px;
  width: 100%;
  font-size: 15px;
}
.code img {
  width: 100%;
  height: 100%;
}
.biaoti {
  /* text-align: center; */
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
}
.pictrueBox {
  display: none;
}
.whiteBg_bottom {
  display: flex;
  align-items: center;
  margin: 0 auto;
  justify-content: center;
  margin-top: 45%;
}
.whiteBg_bottom img {
  width: 20px;
}
.whiteBg_bottom p {
  font-size: 14px;
  color: #999;
}
.whiteBg_bottoms {
  display: flex;
  align-items: center;
  margin: 0 auto;
  justify-content: center;
  margin-top: 30%;
}
.whiteBg_bottoms img {
  width: 20px;
}
.whiteBg_bottoms p {
  font-size: 14px;
  color: #999;
}
</style>
